





























































import { Component, Vue, Prop } from 'vue-property-decorator';
import DetailsSummaryArea from '@/components/common/modules/DetailsSummaryArea.vue';
import { Tax, LabelText } from '@/constants/components/detailsSummaryArea';

@Component({
  components: { DetailsSummaryArea }
})
export default class CostInputDetailsSummaryPanel extends Vue {
  // 親コンポーネントから送られてくるラベル名
  @Prop({ default: LabelText })
  private labelText?: Array<string>;
  // 親コンポーネントから送られてくる集計に用いるメインデータ
  @Prop({ default: 0 })
  private mainData?: Array<any>;
  // 親コンポーネントから送られてくる集計に用いるサブデータ
  @Prop({ default: 10 })
  private subData?: number;
  // 親コンポーネントから送られてくるメインデータで使用するプロパティ
  @Prop({ default: 'value' })
  private mainDataPropertyName?: string;
  // 親コンポーネントから送られてくるサブデータで使用するプロパティ
  @Prop({ default: '' })
  private subDataPropertyName?: string;
  // 親コンポーネントから送られてくる単位情報
  @Prop({ default: '' })
  private unitText?: Array<any>;
  // 親コンポーネントから送られてくる単位情報を表示する位置
  @Prop({ default: '' })
  private unitPosition?: Array<any>;
  // 親コンポーネントの表示タイプ
  @Prop({ default: '' })
  private viewType?: Array<any>;
  private optionalData = Tax.CONSUMPTIONTAX10;

  // 各集計データ格納用配列
  private summaryAreaArray: string[] = [];
  // 受注予定額
  @Prop({ default: '' })
  private orderPrice?: string;

  /**
   * 子コンポーネントからの値を受け取り、各集計データ格納用配列の更新確認を行い、
   * 指定された各集計データ格納用配列内に値がなければ、値を格納する。、
   * @module detailsSummaryAreaOperation
   * @param {[k: string]: string} data - ラベル名、値、集計コンポーネントのインデックス
   * @return {void}
   */
  createDetailsSummaryOperation(data: { [k: string]: string }) {
    const index = Number(data.index);
    // 該当配列の値が更新されているかを確認
    if (data.value !== this.summaryAreaArray[index]) {
      this.summaryAreaArray.splice(index, 0, data.value);
    }
  }
}
